import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function User({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'16px'} height={'16px'} viewBox={'0 0 20 24'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <path
            d={
              'M17,21 C17,21.5522847 16.5522847,22 16,22 C15.4477153,22 15,21.5522847 15,21 L15,19 C15,17.3431458 13.6568542,16 12,16 L5,16 C3.34314575,16 2,17.3431458 2,19 L2,21 C2,21.5522847 1.55228475,22 1,22 C0.44771525,22 0,21.5522847 0,21 L0,19 C2.77555756e-16,16.2385763 2.23857625,14 5,14 L12,14 C14.7614237,14 17,16.2385763 17,19 L17,21 Z M8.5,12 C5.73857625,12 3.5,9.76142375 3.5,7 C3.5,4.23857625 5.73857625,2 8.5,2 C11.2614237,2 13.5,4.23857625 13.5,7 C13.5,9.76142375 11.2614237,12 8.5,12 Z M8.5,10 C10.1568542,10 11.5,8.65685425 11.5,7 C11.5,5.34314575 10.1568542,4 8.5,4 C6.84314575,4 5.5,5.34314575 5.5,7 C5.5,8.65685425 6.84314575,10 8.5,10 Z M22.2928932,8.29289322 C22.6834175,7.90236893 23.3165825,7.90236893 23.7071068,8.29289322 C24.0976311,8.68341751 24.0976311,9.31658249 23.7071068,9.70710678 L19.7071068,13.7071068 C19.3165825,14.0976311 18.6834175,14.0976311 18.2928932,13.7071068 L16.2928932,11.7071068 C15.9023689,11.3165825 15.9023689,10.6834175 16.2928932,10.2928932 C16.6834175,9.90236893 17.3165825,9.90236893 17.7071068,10.2928932 L19,11.5857864 L22.2928932,8.29289322 Z'
            }
          ></path>
        </g>
      </svg>
    </div>
  )
}

User.propTypes = {
  className: PropTypes.string,
}
